import { createApp } from 'vue'
import { ItemAddToCart } from '~/js/components/buttonAddToCart/index.vue'
import FButtonAddToCart from '~/js/components/buttonAddToCart'
const ID_ARTICLE_COLOR_ANALYSIS = 'js-articleColorAnalysis'

document.addEventListener('DOMContentLoaded', () => {
  const elementArticleColorAnalysis = document.getElementById(
    ID_ARTICLE_COLOR_ANALYSIS
  )
  if (!elementArticleColorAnalysis) return

  createApp({
    name: 'ArticleColorAnalysis',
    components: { FButtonAddToCart },
    methods: {
      itemsAddToCart(product, text1, text2) {
        return [
          new ItemAddToCart({
            ...product,
            text1,
            text2,
            id: product.variants?.[0]?.id,
            image: product.featured_image,
            sku: product.handle,
            variantId: product.variants?.[0]?.id,
          }),
        ]
      },
    },
  }).mount(elementArticleColorAnalysis)
})
